export default __webpack_public_path__ + "static/media/single-project-page-05-img-27.a79c3372.jpg";